import React from 'react';
import { Reveal } from './Reveal';
import { PriceBlock } from './PriceBlock';
import { valueRows, PRICE_TODAY, PRICE_FULL } from '../constants/data';
export function ValueTable() {
  return <section id="oferta" className="w-full px-5 py-16 sm:py-24" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-262">
      <div className="mx-auto max-w-3xl" data-id="element-263">
        <Reveal data-id="element-264">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-265">
            📦 Tu Megapack Completo
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-266">
          <div className="mt-10 glass overflow-hidden" data-id="element-267">
            <table className="w-full text-sm sm:text-base" data-id="element-268">
              <thead data-id="element-269">
                <tr className="border-b border-white/10 text-white/60" data-id="element-270">
                  <th className="px-4 sm:px-6 py-3 text-left font-semibold" data-id="element-271">
                    Qué recibís
                  </th>
                  <th className="px-4 sm:px-6 py-3 text-right font-semibold" data-id="element-272">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-273">
                {valueRows.map((row, i) => <tr key={row.item} style={{
                backgroundColor: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)'
              }} data-id="element-274">
                    <td className="px-4 sm:px-6 py-3 text-white/85" data-id="element-275">
                      {row.item}
                    </td>
                    <td className="px-4 sm:px-6 py-3 text-right text-white/70 whitespace-nowrap" data-id="element-276">
                      {row.value}
                    </td>
                  </tr>)}
                <tr style={{
                backgroundColor: 'rgba(0,200,83,0.12)'
              }} data-id="element-277">
                  <td className="px-4 sm:px-6 py-4 font-bold text-white" data-id="element-278">
                    VALOR TOTAL
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-right font-bold whitespace-nowrap" style={{
                  color: '#00C853'
                }} data-id="element-279">
                    {PRICE_FULL}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-280">
          <div className="mt-12" data-id="element-281">
            <PriceBlock ctaLabel={`QUIERO MI MEGAPACK — ${PRICE_TODAY}`} data-id="element-282" />
          </div>
        </Reveal>
      </div>
    </section>;
}